angular.module('components.caOrderRowsDelivery', [])
    .component('caOrderRowsDelivery', {
        templateUrl: 'main/order/orderdelivery/components/orderrowsdelivery.component.tpl.html',
        controllerAs: 'vm',
        bindings: {
            orderChangeCount: '=',
            order: '=',
            links: '<',
            disabled: '<',
            currentOrderArticle: '<'
        },
        controller: controller
    });

// @ngInject    
function controller($scope, $translate, loadSpinnerService, confirmationDialogService, OrdersApiService, ToasterService, OrderService) {
    var vm = this;

    //Properties
    var rowsGrid = {};
    var rowData = [];
    var rowCollection = new wijmo.collections.CollectionView(rowData);
    vm.ongoingRequest = false;
    vm.restCurrentOrderArticle = false;

    //Methods
    vm.$onInit = onInit;
    vm.$onChanges = onChanges;
    vm.$onDestroy = onDestroy;
    vm.setWijmoInputDateLimits = setWijmoInputDateLimits;
    vm.captureRowsGrid = captureRowsGrid;
    vm.deliverOrderSection = deliverOrderSection;
    vm.transferQuantityDataToOrder = transferQuantityDataToOrder;
    vm.recalculateGridTotals = recalculateGridTotals;
    vm.orderArticleIsDelivered = orderArticleIsDelivered;
    vm.canDeliverIn = canDeliverIn;

    function onInit() {
        vm.order.deliveredDate = new Date();

        $scope.$watch(function() { return (vm.currentOrderArticle === undefined || vm.currentOrderArticle.article === undefined) ?
                                          undefined :
                                          vm.currentOrderArticle.article.id; }, function() {
            if (vm.currentOrderArticle !== undefined && vm.currentOrderArticle.article !== undefined) {
                initializeGridColumns();
                loadGridData();
            }
        });

        $scope.$watch(function() { return vm.orderChangeCount; }, function() {
            initializeGridColumns();
            loadGridData();

            if ($scope.$$phase) {
                $scope.$apply();
            }
        });
    }
    function onChanges() {
    }
    function onDestroy() {
    }

    function canDeliverIn() {
        return OrderService.canPartDeliverOrder(vm.links);
    }

    function deliverOrderSection() {
        if (vm.ongoingRequest) {
            console.log("vm.ongoingRequest: " + vm.ongoingRequest);
            return;
        }

        var deliver = function() {
            vm.ongoingRequest = true;

            vm.transferQuantityDataToOrder();
            var orderCopy = angular.copy(vm.order);

            var orderArticle = _.find(orderCopy.orderArticles, function(orderArticle) {
                return orderArticle.id === vm.currentOrderArticle.id;
            });
            orderArticle.shouldDeliverThisArticle = true;

            if (vm.restCurrentOrderArticle) {
                _.forEach(orderArticle.orderRows, function(orderRow) {
                    orderRow.IsFinalDelivery = false;
                });
            } else {
                _.forEach(orderArticle.orderRows, function(orderRow) {
                    orderRow.IsFinalDelivery = true;
                });
            }

            zeroAllNonDeliveryQuantities(orderCopy);
            stripUnnecessaryOrderData(orderCopy);

            orderCopy.plannedDeliveryDate = parseDate(orderCopy.plannedDeliveryDate);

            deliverPart();

            function deliverPart() {
                loadSpinnerService.start('mainSpinner');
                OrdersApiService.deliverPartially(orderCopy).then(function(response) {
                    ToasterService.showSuccess($translate.instant("common.done"));
                    vm.order = response.data;
                    vm.order.deliveredDate = new Date();
                    vm.order.plannedDeliveryDate = parseDate(vm.order.plannedDeliveryDate);
                    vm.currentOrderArticle = _.find(vm.order.orderArticles, function(orderArticle) { return orderArticle.id === vm.currentOrderArticle.id; });

                    resetOrderArticleFlags();

                    vm.orderChangeCount += 1;
                    setInitialQuantitiesToDeliver();
                    setupGrid();
                    loadGridData();
                }, function(error) {
                    ToasterService.showError(error.message);
                }).finally(function() {
                    vm.ongoingRequest = false;
                    loadSpinnerService.stop('mainSpinner');
                });
            }
        }

        if(anyRowsOnCurrentOrderArticleWithPurchaseCostLargerThanSalesPrice()){
            confirmationDialogService.showDialog($translate.instant("order.purchasecostIsLargerMessage"), 'danger').then(function (result) {
                if (result === true) {
                    deliver();
                }
            });
        }
        else {
            deliver();
        }
    }

    function anyRowsOnCurrentOrderArticleWithPurchaseCostLargerThanSalesPrice(){
        return vm.currentOrderArticle.orderRows.some(function(orderRow){
            return orderRow.systemStatus !== 'delivered' && 
                orderRow.systemStatus !== 'voided' &&
                orderRow.purchaseCost > orderRow.articleVariant.salesPrice
        });
    }

    function resetOrderArticleFlags() {
        _.forEach(vm.order.orderArticles, function(orderArticle) {
            orderArticle['shouldDeliverThisArticle'] = false;

            _.forEach(orderArticle.orderRows, function(orderRow) {
                orderRow['hasBeenModifiedSinceLoad'] = false;
            });
        });
    }

    function zeroAllNonDeliveryQuantities(order) {
        _.forEach(order.orderArticles, function(orderArticle) {
            if (!orderArticle.shouldDeliverThisArticle) {
                _.forEach(orderArticle.orderRows, function(orderRow) {
                    orderRow.quantity = 0;
                });
            }
        });
    }

    function stripUnnecessaryOrderData(order) {
        order.orderArticles = _.filter(order.orderArticles, function(oa) { return oa.shouldDeliverThisArticle && oa.shouldDeliverThisArticle === true; });
        _.forEach(order.orderArticles, function(orderArticle) {
            orderArticle.article = undefined;
            _.forEach(orderArticle.orderRows, function (ordRow) {
                _.forEach(ordRow.deliveryRows, function(delRow) {
                    if (delRow.location) { delRow.location = { id: delRow.location.id }; }
                    if (delRow.deliveringUser) { delRow.deliveringUser = { id: delRow.deliveringUser.id }; }
                    if (delRow.articleVariant) { delRow.articleVariant = { id: delRow.articleVariant.id }; }
                });
            });
        });
        if (order.purchaser) { order.purchaser = { id: order.purchaser.id }; }
        if (order.destination) { order.destination = { id: order.destination.id }; }
        if (order.company) { order.company = { id: order.company.id }; }
        if (order.user) { order.user = { id: order.user.id }; }
        if (order.collection) { order.collection = { id: order.collection.id }; }
        if (order.fromLocation) { order.fromLocation = { id: order.fromLocation.id }; }
    }

    //Transform from string to Date, and make sure date has correct timezone and no time information
	function parseDate(input) {
		if (!(input instanceof Date)) {
            var newDate = new Date(input);
            return new Date(Date.UTC(newDate.getFullYear(), newDate.getMonth(), newDate.getDate()));
		} else {
			return new Date(Date.UTC(input.getFullYear(), input.getMonth(), input.getDate()));
		}
	}

    function setWijmoInputDateLimits(s) {
        if (vm.order.earliestAllowedDeliveryDate) {
            s.min = parseDate(vm.order.earliestAllowedDeliveryDate);
        } else {
            s.min = new Date(2016, 1, 1, 0, 0, 0, 0);
        }
        s.max = parseDate(new Date());
    }

    function captureRowsGrid(grid) {
        rowsGrid = grid;
        rowsGrid.initialize({
            autoGenerateColumns: false,
            selectionMode: wijmo.grid.SelectionMode.Row,
            allowDragging: wijmo.grid.AllowDragging.None,
            allowResizing: wijmo.grid.AllowResizing.Columns,
            frozenColumns: 2,
            itemsSource: rowCollection
        });

        setupGrid();

        if (vm.order.id !== undefined) {
            loadGridData();
        }
    }

    function setupGrid() {
        rowData.length = 0;
        rowsGrid.finishEditing(true);
        rowsGrid.columns.clear();
        rowsGrid.invalidate();
        rowCollection.refresh();
        initializeGridColumns();

        rowsGrid.beginningEdit.addHandler(function (s, e) {
            var col = rowsGrid.columns[e.col];
            var dataItem = rowsGrid.rows[e.row].dataItem;
            var deliveryItemExists = _.has(dataItem, col.header);

            if (!deliveryItemExists) { // enable editing for the cell with id 0 in column 1
                e.cancel = true;
            }
        });
    }

    function loadGridData() {
        rowData.length = 0;

        var currentOrderArticle = _.find(vm.order.orderArticles, function(orderArticle) {
            return orderArticle.articleId === vm.currentOrderArticle.articleId;
        });

        if (!currentOrderArticle) {
            return;
        }

        var variantRows = _.groupBy(currentOrderArticle.orderRows, function(orderRow) {
            return orderRow.articleVariant.variantDetail1.variantDetailName;
        });

        _.forEach(variantRows, function(variantRowValues) {
            var r = {};
            var sum = 0;
            _.forEach(variantRowValues, function(variantRowValue) {
                r.variantDetails1Name = variantRowValue.articleVariant.variantDetail1.variantDetailName;

                r.variantExternalId = variantRowValue.articleVariant.externalId;

                var summarizedDeliveredQuantity = 0;
                var summarizedUndeliveredQuantity = 0;
                _.forEach(variantRowValue.deliveryRows, function(deliveryRow) {
                    if (deliveryRow.systemStatus !== 'delivered' && deliveryRow.deliveryRowType === 'deliveryIn') {
                        summarizedUndeliveredQuantity += deliveryRow.quantity;
                    } else if (deliveryRow.systemStatus !== 'delivered' && deliveryRow.deliveryRowType === 'deliveryOut' && vm.order.orderType.orderSystemType === "return") {
                        summarizedUndeliveredQuantity += -deliveryRow.quantity;
                    }
                });
                r[variantRowValue.articleVariant.variantDetail2.variantDetailName] = summarizedUndeliveredQuantity;

                // Instead of displaying a negative value as the amount to be delivered in.
                if (parseInt(r[variantRowValue.articleVariant.variantDetail2.variantDetailName]) < 0) {
                    r[variantRowValue.articleVariant.variantDetail2.variantDetailName] = "0";
                }

                var someRowIsUndelivered = false;
                _.forEach(vm.currentOrderArticle.orderRows, function(orderRow) {
                    if (orderRow.systemStatus.toLowerCase() !== 'delivered') {
                        someRowIsUndelivered = true;
                    }
                });

                // If the orderArticle is fully delivered, show the delivered quantities in the grid.
                if (!someRowIsUndelivered) {
                    r[variantRowValue.articleVariant.variantDetail2.variantDetailName] =
                        _.reduce(variantRowValue.deliveryRows, function(memo, dlvrRow) {
                            if (dlvrRow.deliveryRowType === "deliveryIn") {
                                return memo + dlvrRow.quantity;
                            }
                            return memo;
                        }, 0);
                }

                sum += parseInt(r[variantRowValue.articleVariant.variantDetail2.variantDetailName]);
            });
            r['rowTotal'] = sum;
            rowData.push(r);
        });
        rowCollection.refresh();
    }

    function initializeGridColumns() {
        if (!rowsGrid.columns) {
            return;
        }

        rowsGrid.columns.length = 0;

        // Add first row header column
        var rowHeader = new wijmo.grid.Column();
        rowHeader.binding = "variantDetails1Name";
        rowHeader.header = ' ';
        rowHeader.allowSorting = false;
        rowHeader.allowResizing = true;
        rowHeader.width = 200;
        rowHeader.minWidth = 100;
        rowHeader.isReadOnly = true;
        rowsGrid.columns.push(rowHeader);

        var columns = getDataColumns();

        if (columns.length > 1) {
            var rowTotalCol = new wijmo.grid.Column();
            rowTotalCol.header = $translate.instant('customerorder.totalquantity');
            rowTotalCol.allowSorting = false;
            rowTotalCol.width = 100;
            rowTotalCol.minWidth = 100;
            rowTotalCol.isReadOnly = true;
            rowTotalCol.binding = "rowTotal";
            rowTotalCol.align = "right";
            rowsGrid.columns.push(rowTotalCol);
        }

        // Add dynamic columns
        _.forEach(columns, function (variantDetail) {
            var c = new wijmo.grid.Column();
            c.binding = variantDetail.variantDetailName;
            c.header = variantDetail.variantDetailName;
            c.width = '*';
            c.minWidth = 100;
            c.allowSorting = false;
            c.allowResizing = true;
            c.inputType = 'text';
            c.isReadOnly = !canDeliverIn();
            c.align = "right";
            rowsGrid.columns.push(c);
        });
    }

    function getDataColumns() {
        var columns = [];

        var articleVariants = [];

        if (vm.currentOrderArticle !== undefined) {
            _.forEach(vm.currentOrderArticle.orderRows, function(orderRow) {
                articleVariants.push(orderRow.articleVariant);
            });
        }

        // Group by nested variantDetail2 in the current articleVariants
        columns = _.groupBy(articleVariants, function(variant) {
            return variant.variantDetail2.variantDetailName;
        });
        // Get the variantDetail2 from each group in an array
        columns = _.reduce(columns, function(newArray, val, key) {
            newArray.push(val[0].variantDetail2);
            return newArray;
        }, []);

        return _.sortBy(columns, 'sortOrder');
    }

    function transferQuantityDataToOrder() {
        var currentOrderArticle = _.find(vm.order.orderArticles, function(orderArticle) {
            return vm.currentOrderArticle.article.id === orderArticle.article.id;
        });

        _.forEach(currentOrderArticle.orderRows, function(orderRow) {
            var row = _.find(rowData, function(row) {
                return row['variantDetails1Name'] === orderRow.articleVariant.variantDetail1.variantDetailName;
            });
            if (row !== undefined) {
                orderRow.quantity = parseInt(row[orderRow.articleVariant.variantDetail2.variantDetailName]);
            }
        });
    }

    function recalculateGridTotals() {
        var variant2Details = [];
        _.forEach(vm.currentOrderArticle.orderRows, function(orderRow) {
            if (!_.find(variant2Details, function(vd) { return vd.id === orderRow.articleVariant.variantDetail2.id; })) {
                variant2Details.push(orderRow.articleVariant.variantDetail2);
            }
        });

        var variant1Details = [];
        _.forEach(vm.currentOrderArticle.orderRows, function(orderRow) {
            if (!_.find(variant1Details, function(vd) { return vd.id === orderRow.articleVariant.variantDetail1.id; })) {
                variant1Details.push(orderRow.articleVariant.variantDetail1);
            }
        });

        _.forEach(variant1Details, function(vd1) {
            var quantitySum = 0;
            var row = _.find(rowData, function(row) { return row.variantDetails1Name === vd1.variantDetailName; });
            _.forEach(variant2Details, function(vd2) {
                var deliveryItemExists = _.has(row, vd2.variantDetailName);
                if (deliveryItemExists) {
                    quantitySum += parseInt(row[vd2.variantDetailName]);
                }
            });
            row['rowTotal'] = quantitySum;
        });

        rowsGrid.invalidate();
    }

    function orderArticleIsDelivered() {
        var orderRowsToCheck = _.filter(vm.currentOrderArticle.orderRows, function(orderRow) { return orderRow.id !== 0; });

        var isDelivered = _.every(orderRowsToCheck, function(orderRow) {
            return orderRow.systemStatus.toLowerCase() === 'delivered';
        });

        return isDelivered;
    }


    //FUNCTIONS FROM "orderarticles.components.js"
    function setInitialQuantitiesToDeliver() {
        _.forEach(vm.order.orderArticles, function(orderArticle) {
            if (isMultipleVariantArticle(orderArticle)) {
                return true;
            }
            orderArticle.restOrderArticle = false;
            orderArticle.deliveredDate = Date.now();
            _.forEach(orderArticle.orderRows, function(orderRow) {
                var deliveredQuantity = _.sumBy(orderRow.deliveryRows, function(deliveryRow) {
                    if (deliveryRow.systemStatus === "delivered" && deliveryRow.deliveryRowType === "deliveryIn") {
                        return deliveryRow.quantity;
                    }
                });
                if (deliveredQuantity === undefined) {
                    deliveredQuantity = 0;
                }
                orderRow.quantityToDeliver = Math.max(orderRow.quantity - deliveredQuantity, 0);
            });
        });
    }

    function isSingleVariantArticle(article) {
        return !article.isVariant || (article.articleVariants !== undefined && article.articleVariants.length < 2);
    }

    function isMultipleVariantArticle(article) {
        return !isSingleVariantArticle(article);
    }
}
